import { margin } from "ds_legacy/materials/metrics";
import { TextAreaWithLabel } from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const CHARACTER_LIMIT_DESCRIPTION_TEXT = 780;

export const TransitionalCareDescription = () => {
  const translations = useTranslations();

  return (
    <TextAreaWithLabel
      characterLimit={CHARACTER_LIMIT_DESCRIPTION_TEXT}
      elementName="transitional_care_description"
      label={
        translations.patientForms.transitionalCareForm.sectionB.textFieldLabel
      }
      multiline
      sx={{ margin: margin(0) }}
    />
  );
};
